import { differenceInMinutes, differenceInCalendarDays, differenceInHours, differenceInWeeks, differenceInMonths, differenceInSeconds, add } from 'date-fns';

const dateDiffKey = [
  [differenceInMonths, 'months'],
  [differenceInWeeks, 'weeks'],
  [differenceInCalendarDays, 'days'],
  [differenceInHours, 'hours'],
  [differenceInMinutes, 'minutes'],
  [differenceInSeconds, 'seconds'],
];

export const fullDateDiff = (laterDate, earlierDate) => {
  const diffs = dateDiffKey.reduce((acc, timeData) => {
    const diff = timeData[0](laterDate, acc.dateMarker);
    if (diff <= 0) return acc;
    const duration = { [ timeData[1] ]: diff };
    return {...acc, ...duration, dateMarker: add(acc.dateMarker, duration)}
  }, {dateMarker: earlierDate})
  return Object.keys(diffs).map(( diffKey) => {
    if (diffKey === 'dateMarker') return '';
    const value = diffs[diffKey];
    const unit = value === 1 ? diffKey.replace(/s$/, '') : diffKey;
    return `${value} ${unit}`
  }).join(' ');
}